// extracted by mini-css-extract-plugin
export default {"wrapper":"Questions_wrapper__FpnV2","content":"Questions_content__7l65w"};